export default "/assets/images/chart-06.2618d77346bdc223.svg";